import apiClient from '../apiClient'

// VMD 요청사항 상태 코드
const VMD_STATUS = {
  NOT_CHECK: 125, // 안읽음
  CHECKED: 126, // 미제출
  SUBMITTED: 127, // 제출완료
  REQUEST: 128, // 보완요청
  APPROVED: 129, // 담당자승인
  RESUBMITTED: 130, // 보완제출
}

const vmdAPI = {
  // VMD 요청사항 목록 조회
  getVmdRequests: (page, limit) =>
    apiClient.get('/vmd/requests', {
      params: {
        page,
        limit,
        fields: 'id,title,date,due_date,status_name,status_code',
      },
    }),

  // VMD 요청사항 상세 조회
  getVmdRequestDetail: id =>
    apiClient.get(`/vmd/requests/${id}`, {
      params: {
        fields: 'id,title,content,date,due_date,status_name,status_code',
      },
    }),

  // VMD 요청사항 상태 업데이트
  updateStatus: (id, status_code) =>
    apiClient.post(`/vmd/requests/${id}/status`, {
      status_code,
    }),

  // VMD 요청사항 제출
  submitReport: async (id, formData) => {
    return apiClient.post(`/vmd/requests/${id}/submit`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // VMD 제출 목록 조회
  getVmdSubmissions: (page, limit) =>
    apiClient.get('/vmd/submissions', {
      params: {
        page,
        limit,
        fields:
          'id,title,date,status_name,status_code,comment,report_result,report_result_comment',
        sort: '-date', // 최신순 정렬
      },
    }),

  // VMD 제출 상세 조회
  getVmdSubmissionDetail: submissionId =>
    apiClient.get(`/vmd/submissions/${submissionId}`),

  // VMD 제출 수정
  updateReport: async (id, formData) => {
    // FormData를 객체로 변환하여 확인
    const formDataObj = {}
    formData.forEach((value, key) => {
      formDataObj[key] = value
    })
    console.log('FormData 내용:', JSON.stringify(formDataObj, null, 2))

    return apiClient.put(`/vmd/submission/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  // 상태 코드 상수 export
  VMD_STATUS,
}

export default vmdAPI
